import { Component, OnInit } from '@angular/core';
import { DashboardHelper } from '../../../services/dashboard.service';
import { BaseComponent } from '../../base/base.component';
import { WorkspaceStore } from '../../../services/stores/workspace.store';
import { LoggerService } from '../../../services/logger.service';
import * as AppConstants from '../../../modules/catch-core/data/constants/app.constants';

@Component({
  selector: 'app-roll-up',
  templateUrl: './roll-up.component.html',
  styleUrls: ['./roll-up.component.css'],
  standalone: false,
})
export class RollUpComponent extends BaseComponent implements OnInit {
  private lastAppLoaded = '';
  public isRollUp = true;
  public isReportApp = true;
  public subscribers: any = {};
  private className = 'RollUpComponent';
  constructor(
    private loggerService: LoggerService,
    private workspaceStore: WorkspaceStore,
    private dashboardHelper: DashboardHelper,
  ) {
    super();
  }

  ngOnInit() {
    this.subscribers.currentETApplication = this.dashboardHelper.$currentApplication.subscribe((res: any) => {
      // console.log('RollUpComponent >> ngOnInit >> currentETApplication');
      if (res) {
        // console.log(res.displayName);
        const currentAppName = res.displayName.toLowerCase();
        if (currentAppName === AppConstants.CATCH_INTERNAL_APP_REPORT_LOWER) {
          // this.userPreferenceStore.setIsWorkspaceRollup(true);
          this.isReportApp = true;
          this.isRollUp = true;
        } else {
          // this.userPreferenceStore.setIsWorkspaceRollup(false);
          this.isReportApp = false;
          this.isRollUp = false;
          // if (this.lastAppLoaded === 'report') { // if we are switching from report to other apps, we need to load as roll up false, so refresh it to keep it simple
          //   this.loggerService.traceCaller(this.className, this.ngOnInit.name, 'currentETApplication changed->rollup', 'false');
          //   this.onIsRoolUpReportChange(false);
          // }
        }
        this.lastAppLoaded = res.displayName.toLowerCase();
      }
    });
  }

  public onIsRoolUpReportChange(value: any) {
    //this.loggerService.traceEnter(this.className, this.onIsRoolUpReportChange.name, 'getWorkspaceById >> null', value);
    if (this.subscribers.workspaceById) {
      this.subscribers.workspaceById.unsubscribe();
    }
    this.loggerService.traceCaller(this.className, this.onIsRoolUpReportChange.name, 'getWorkspaceById >> null', value);
    // dont pass workspace id as store already has it
    this.workspaceStore.isRollup = value;
    this.subscribers.workspaceById = this.workspaceStore.$getWorkspaceById(null).subscribe();
  }
}
